<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { useModal } from "#/composables/useModal";

interface Context {
	callback: () => void;
}

interface Emits {
	confirm: [];
}

const { t } = useTranslation();
const { visible, context, close } = useModal<Context>("cart-promo-reset-confirm");
const emit = defineEmits<Emits>();

const onConfirm = () => {
	if (context.value?.callback) context.value.callback();
	emit("confirm");
	close();
};
</script>

<template>
	<Transition name="fade-scale">
		<div v-if="visible" class="cart_promo_reset_confirm_modal_overlay">
			<div class="cart_promo_reset_confirm_modal_content">
				<div class="cart_promo_reset_confirm_modal_title">{{ t(`modal.cart-promo-reset-confirm.title`) }}</div>
				<div class="cart_promo_reset_confirm_modal_body">{{ t(`modal.cart-promo-reset-confirm.body`) }}</div>
				<div class="cart_promo_reset_confirm_modal_footer">
					<button type="button" class="primary" @click="onConfirm">{{ t(`modal.cart-promo-reset-confirm.button.confirm`) }}</button>
					<button type="button" @click="close">{{ t(`modal.cart-promo-reset-confirm.button.cancel`) }}</button>
				</div>
			</div>
		</div>
	</Transition>
</template>

<style lang="scss" scoped>
  @use './cartPromoResetConfirm.scss';
</style>
